import { render, staticRenderFns } from "./BasicScrollArea.vue?vue&type=template&id=5e0b9d46&scoped=true&"
var script = {}
import style0 from "./BasicScrollArea.vue?vue&type=style&index=0&id=5e0b9d46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0b9d46",
  null
  
)

export default component.exports